// extracted by mini-css-extract-plugin
export var navStyle = "navigation-module--navStyle--3oucz";
export var navLink = "navigation-module--navLink--271wt";
export var activeLink = "navigation-module--activeLink--Pk7TH";